<div *ngIf="loading" class="spinner">
  <div class="sk-spinner sk-spinner-pulse"></div>
</div>

<form *ngIf="form" (ngSubmit)="onSubmit()" [formGroup]="form" class="pos-relative form mb-10">
  <div class="form-group my-15 sender-input">
    <label class="form-label required">Sender ID</label>
    <input formControlName="name" type="text" class="form-control" required>
    <input-errors [control]="form.controls.name" [service]="validationService"></input-errors>
  </div>

  <div class="form-area d-flex justify-content-start align-items-start">
    <div class="side text-list">
      <p class="text-primary pt-10">TEXT TEMPLATES</p>
      <div class="text-item cp" [ngClass]="{'active': selectedTextTemplateIndex === i}" *ngFor="let stt of smsTextTemplatesForm.controls;let i = index"
        (click)="setActiveTextTemplate(i)">
        <span [innerHTML]="renderTemplateValue(stt.get('value').value)"> </span>
      </div>
    </div>
    <div class="form-container" formArrayName="smsTemplateTextDtos">
      <div class="template-step" *ngFor="let stt of smsTextTemplatesForm.controls; let i=index">
        <div [hidden]="selectedTextTemplateIndex !== i">
          <div class="title d-flex justify-content-start align-items-center mt-10">
            <span class="d-flex justify-content-start align-items-center fs-4">Text template {{i + 1}}</span>
            <a (click)="onFavouriteClick(i)" class="cp"><span class="icon-favourite" [ngClass]="{'marked': isFavourite(i)}"></span></a>
            <a *ngIf="!isDisabled(stt) && smsTextTemplatesForm.controls.length !== 1" (click)="deleteSmsTextTemplates(stt, i)" class="cp text-error-r2"><span
                class="far fa-trash-alt"></span></a>
          </div>

          <fieldset [disabled]="isDisabled(stt)" [formGroupName]="i">
            <div class="form-row d-flex justify-content-between align-items-center my-15">
              <div class="form-group text-field-container">
                <label class="form-label required">Text</label>
                <app-text-template tabindex="0" [isDisabled]="isDisabled(stt)" class="app-text-template"
                  (changeText)="onChangeText($event, stt)"></app-text-template>
                <input-errors [control]="getFormControl(stt, 'value')" [service]="validationService"></input-errors>
              </div>

              <div class="form-group">
                <label class="form-label">Description </label>
                <textarea tabindex="1" formControlName="description" type="text" class="form-control description"></textarea>
                <input-errors [control]="getFormControl(stt, 'description')" [service]="validationService"></input-errors>
              </div>
            </div>

            <div class="form-row d-flex justify-content-between align-items-center my-15">
              <div class="form-group">
                <label class="form-label">TelQ ID Type </label>
                <div class="select-items d-flex justify-content-start">
                  <select (change)="onChangeType($event, stt, i)" formControlName="telqIdType" class="form-control">
                    <option *ngFor="let type of types" [value]="type.id">{{type.label}}</option>
                  </select>
                  <input-errors [control]="getFormControl(stt, 'telqIdType')" [service]="validationService"></input-errors>
                </div>
              </div>

              <div class="form-group" *ngIf="checkIfControlPresent(stt, 'telqIdCase')" [@slideFadeInOut]>
                <label class="form-label">TelQ ID Case </label>
                <div class="select-items d-flex justify-content-start">
                  <select formControlName="telqIdCase" class="form-control">
                    <option *ngFor="let c of cases" [value]="c.id">{{c.label}}</option>
                  </select>
                  <input-errors [control]="getFormControl(stt, 'telqIdCase')" [service]="validationService"></input-errors>
                </div>
              </div>

              <div class="form-group" *ngIf="checkIfControlPresent(stt, 'telqIdLength')" [@slideFadeInOut]>
                <label class="form-label">TelQ ID Length </label>
                <input formControlName="telqIdLength" type="number" class="form-control" required>
                <input-errors [control]="getFormControl(stt, 'telqIdLength')" [service]="validationService"></input-errors>
              </div>
            </div>

            <div class="form-row d-flex justify-content-between align-items-center my-15">
              <div class="form-group">
                <label class="form-label">Message Type</label>
                <div class="select-items d-flex justify-content-start">
                  <select formControlName="messageType" class="form-control">
                    <option *ngFor="let messageType of messageTypes" [value]="messageType.id">{{messageType.label}}</option>
                  </select>
                  <input-errors [control]="getFormControl(stt, 'messageType')" [service]="validationService"></input-errors>
                </div>
              </div>
              <div class="form-group">
                <label class="form-label">User </label>
                <input formControlName="user" type="text" class="form-control">
              </div>

              <div class="form-group" *ngIf="isAdmin">
                <label class="form-label">Visible all</label>
                <div class="form-check form-switch">
                  <input type="checkbox" class="form-check-input" formControlName="visibleAll" (change)="onVisibleAllToggleChange($event, i)" />
                </div>
              </div>
            </div>
          </fieldset>
        </div>
      </div>
    </div>
  </div>

  <a (click)="addSmsTextTemplate()" class="btn btn-outline-primary my-10 px-15"><span class="icon-add"></span>Add new text template</a>
  <hr>
  <div class="buttons d-flex justify-content-between align-items-center">
    <button *ngIf="backButtonShow" (click)="onCancelClick()" class="btn btn-outline-dark px-15">Cancel</button>
    <button id="btn-template-apply" type="submit" [disabled]="!form.valid" class="btn btn-primary px-15">Save</button>
  </div>
</form>

<ng-template #deleteModalTpl let-dialogRef="dialogRef">
  <deletemodal [dialogRef]="dialogRef"></deletemodal>
</ng-template>
